import React, { useMemo } from 'react';
import PerfectScrollBar from 'react-perfect-scrollbar';
import classnames from 'classnames';
import OrgRow from '../OrgRow';
import './style.scss';

const OrgTable = ({
  path,
  className,
  data,
  headers,
  gridTemplateColumns,
  rowRenderer = (org) => null,
  rowDetailsRenderer = (org) => null,
  onOrgEdit = (org) => null,
  onOrgExpandChange = (org, isExpanded) => null,
  queryParams,
}) => {
  const memoGridTemplateColumns = useMemo(() => `${gridTemplateColumns} 65px 0px`, [gridTemplateColumns]);

  return <div className={classnames("org-settings-table", className)}>
    <div
      className="org-settings-table__head"
      style={{
        gridTemplateColumns: memoGridTemplateColumns,
      }}
    >
      {headers.map((header) => (<div className="org-settings-table__heading">
        {header}
      </div>))}
    </div>
    <PerfectScrollBar className="org-settings-table__body">
      {
        data.map(org => <OrgRow
          key={org.id}
          org={org}
          gridTemplateColumns={memoGridTemplateColumns}
          onOrgEdit={() => onOrgEdit(org)}
          onOrgExpandChange={(isExpanded) => onOrgExpandChange(org, isExpanded)}
          rowRenderer={rowRenderer}
          rowDetailsRenderer={rowDetailsRenderer}
          path={path}
          queryParams={queryParams}
        />)
      }
    </PerfectScrollBar>
  </div>
};

export default OrgTable;
